// RequestPasswordReset.js
import React, { useState } from "react";
import { requestPasswordReset } from "../../../service-layer/EmailService";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/NavBar";
import { useTranslation } from "react-i18next";

const RequestPasswordReset = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    if (email.trim() === "") {
      alert(t("email_field_required"));
      return;
    }
    if (!validateEmail(email)) {
      alert(t("email_not_valid"));
      return;
    }

    try {
      await requestPasswordReset(email);
      alert("Password reset email sent.");
      navigate("/login");
    } catch (error) {
      console.error(error);
      alert("An error occurred. Please try again.");
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <div className="d-flex">
      <div
        style={{
          flex: "1 1 auto",
          display: "flex",
          flexFlow: "column",
          height: "100vh",
          overflowY: "hidden",
        }}
      >
        <Navbar />
        <div style={{ height: "100%" }}>
          <div className="login-container">
            <div className={`form-container signup`}>
              <form className="form" onSubmit={handleSubmit}>
                <>
                  <h2>{t("reset_password")}</h2>
                  <input
                    type="email"
                    placeholder={t("email_address")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className={`input-field ${formSubmitted && !validateEmail(email) ? "error" : ""}`}
                  />
                  {formSubmitted && !validateEmail(email) && (
                    <p className="error-text">{t("email_not_valid")}</p>
                  )}
                  <div className="form-button" onClick={handleSubmit}>
                    {t("send_request")}
                  </div>
                </>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
